// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"92":"1255e1b6","230":"df78973b","594":"49052931","861":"5b6eba4d"}[chunkId] + ".js";
};